var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61719 5.625L7.99219 13.582L11.7578 5.625H4.61719Z",
    fill: "#72ADF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61719 5.625L7.99219 13.582L11.7578 5.625H4.61719Z",
    fill: "url(#paint0_linear_6150_92821)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61719 5.625L7.99219 13.582L11.7578 5.625H4.61719Z",
    fill: "url(#paint1_linear_6150_92821)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77344 2.48438L1.02344 6.1875H5.53906L8 2.48438H3.77344Z",
    fill: "url(#paint2_linear_6150_92821)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77344 2.48438L1.02344 6.1875H5.53906L8 2.48438H3.77344Z",
    fill: "url(#paint3_linear_6150_92821)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77344 2.48438L1.02344 6.1875H5.53906L8 2.48438H3.77344Z",
    fill: "url(#paint4_linear_6150_92821)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2148 2.48438L14.9648 6.1875H10.4492L7.98828 2.48438H12.2148Z",
    fill: "url(#paint5_radial_6150_92821)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2148 2.48438L14.9648 6.1875H10.4492L7.98828 2.48438H12.2148Z",
    fill: "url(#paint6_linear_6150_92821)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99512 13.5869L1.02344 6.1875H5.53906L7.99512 13.5869Z",
    fill: "url(#paint7_linear_6150_92821)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99512 13.5869L1.02344 6.1875H5.53906L7.99512 13.5869Z",
    fill: "url(#paint8_linear_6150_92821)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 13.582L14.9668 6.1875H10.4512L7.99219 13.582Z",
    fill: "url(#paint9_radial_6150_92821)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 13.582L14.9668 6.1875H10.4512L7.99219 13.582Z",
    fill: "url(#paint10_linear_6150_92821)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 13.582L14.9668 6.1875H10.4512L7.99219 13.582Z",
    fill: "url(#paint11_linear_6150_92821)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53906 6.18747H10.4492L7.99414 2.49316L5.53906 6.18747Z",
    fill: "url(#paint12_linear_6150_92821)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6150_92821",
    x1: 8.1875,
    y1: 5.92421,
    x2: 8.1875,
    y2: 6.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73AEF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6150_92821",
    x1: 9.59559,
    y1: 11.0565,
    x2: 7.97371,
    y2: 10.7454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73AEF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6150_92821",
    x1: 5.58594,
    y1: 6,
    x2: 3.61719,
    y2: 3.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329505,
    stopColor: "#2E97D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C82CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6150_92821",
    x1: 1.24219,
    y1: 6.53125,
    x2: 3.14844,
    y2: 5.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8BDB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6150_92821",
    x1: 6.78507,
    y1: 4.73557,
    x2: 6.35182,
    y2: 4.45785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B3EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6150_92821",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.99219 4.75) rotate(-5.73208) scale(4.14573 5.60316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20D5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20BFF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6150_92821",
    x1: 9.78906,
    y1: 5.29687,
    x2: 10.1016,
    y2: 5.09375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#20D0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20D0F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6150_92821",
    x1: 4.50928,
    y1: 6.1875,
    x2: 7.99512,
    y2: 13.3671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.379031,
    stopColor: "#296BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E7DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6150_92821",
    x1: 4.50928,
    y1: 6.1875,
    x2: 4.50928,
    y2: 6.39063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D75D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D75D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_6150_92821",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.61719 13.2813) rotate(-60.9647) scale(5.89743 3.09209)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3294E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6150_92821",
    x1: 8.78125,
    y1: 10.9492,
    x2: 9.03125,
    y2: 11.0469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#368FE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#368FE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6150_92821",
    x1: 11.4795,
    y1: 6.03125,
    x2: 11.4795,
    y2: 6.54687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#309EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309EE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6150_92821",
    x1: 9.83594,
    y1: 4.15622,
    x2: 5.53906,
    y2: 7.15622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642405,
    stopColor: "#68CAEA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.2f99e5d3.svg";
export { ForwardRef as ReactComponent };